import { useState, useRef, useEffect } from 'react'

export const useEllipsisCheck = () => {
  const [isEllipsis, setIsEllipsis] = useState([])
  const elementRefs = useRef([])

  const checkEllipsis = () => {
    elementRefs.current.forEach((element, index) => {
      if (element) {
        const isEllipsisActive = element.scrollWidth > element.clientWidth
        setIsEllipsis(prev => {
          const newStatus = [...prev]
          newStatus[index] = isEllipsisActive
          return newStatus
        })
      }
    })
  }

  useEffect(() => {
    checkEllipsis()
    window.addEventListener('resize', checkEllipsis)
    return () => window.removeEventListener('resize', checkEllipsis)
  }, [])

  return { isEllipsis, elementRefs }
}
